/**
 * Base stats DTO
 */
export abstract class BaseStatsDto {
	total!: number;
}
